import { connect } from "react-redux";
import { useEffect } from "react";
import ExportHistoryLoadingMessage from "./ExportHistoryLoadingMessage";
import useExportsPageControls from "../useExportsPageControls";
import {
  searchGenericExportHistory,
  storeGenericExportHistorySearchResults,
} from "../../Store/mutations";
import ExportHistoryFilter from "./ExportHistoryFilter";

const ExportHistorySearchHeader = ({
  itemCount,
  pageNumber,
  pageSize,
  refreshExportHistory,
}) => {
  const { handleExportsPageChange, handleExportsPageSizeChange } =
    useExportsPageControls();

  useEffect(() => {
    if (itemCount <= 0) {
      return;
    }
    if (pageNumber > itemCount / pageSize) {
      handleExportsPageChange("exportHistory", Math.ceil(itemCount / pageSize));
    }
    if (pageNumber === 0) {
      handleExportsPageChange("exportHistory", 1);
    }
  }, [pageSize, pageNumber, itemCount, handleExportsPageChange]);

  //temporarily disabled pagination element - pending a valid method to get accurate count of search result
  // const getMaxPages = () => {
  //   if (isNaN(pageItemCount)) return 1;
  //   return Math.ceil(pageItemCount < pageSize ? 1 : pageItemCount / pageSize);
  // };

  return (
    <ExportsSearchHeaderPure
      handleExportsPageSizeChange={handleExportsPageSizeChange}
      pageSize={pageSize}
      refreshExportHistory={refreshExportHistory}
    />
  );
};

const mapStateToProps = (state) => ({
  pageNumber: state.pageControls.exportHistory.pageNumber,
  pageSize: state.pageControls.exportHistory.pageSize,
  itemCount: state.exportHistory.length,
});

const mapDispatchToProps = (dispatch) => ({
  refreshExportHistory: () => {
    dispatch(storeGenericExportHistorySearchResults([]));
    dispatch(searchGenericExportHistory());
  },
});

const ConnectedExportHistorySearchHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportHistorySearchHeader);
export default ConnectedExportHistorySearchHeader;

export const ExportsSearchHeaderPure = ({
  pageSize,
  handleExportsPageSizeChange,
  refreshExportHistory,
}) => {
  return (
    <>
      <div id="content-header" className="exportsHeader">
        <div className="exportHeaderLeft">
          <ExportHistoryLoadingMessage />
        </div>

        <div className="flex-right paginationControl exportHeaderRight">
          <ExportHistoryFilter />
          <select
            className="paginationElement"
            defaultValue={pageSize}
            onChange={(e) =>
              handleExportsPageSizeChange("exportHistory", e.target.value)
            }
          >
            <option value={50}>50 Per Page</option>
            <option value={100}>100 Per Page</option>
            <option value={250}>250 Per Page</option>
          </select>
          <button
            className="refreshButton"
            onClick={() => refreshExportHistory()}
          >
            Refresh
          </button>
        </div>
      </div>
    </>
  );
};
